import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { PasswordResetRequest, UpdateQueuedPasswordPayload } from '../../types/password-reset'

/** Admin password-reset queue — components call this service only. */
export const passwordResetService = {
  async list(params?: { search?: string; page?: number; per_page?: number }) {
    const { data } = await apiClient.get<
      ApiPaginatedResponse<PasswordResetRequest> | ApiSuccessResponse<PasswordResetRequest[]>
    >('/reset-password/list', { params })
    return data
  },

  async updateUserPassword(payload: UpdateQueuedPasswordPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<null>>(
      '/reset-password/update/user/password',
      payload,
    )
    return data
  },
}
